import { configureStore } from "@reduxjs/toolkit"
import { clientConfigApi } from "@/hooks/useClientConfig"

const store = configureStore({
  reducer: {
    [clientConfigApi.reducerPath]: clientConfigApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(clientConfigApi.middleware)
})

export default store
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch